export default "__VITE_ASSET__1d297b3b__"